import { createFileRoute } from "@tanstack/react-router";
import { useBestillingContext } from "@/features/bestillinger";
import {
  BestillerPrivatPage,
  BestillerSelskapPage,
} from "@/features/bestillinger/pages";

export const Route = createFileRoute("/_app/bestilling/ny/bestiller/")({
  component: () => {
    const { bestilling } = useBestillingContext();
    switch (bestilling.aktoer?.type) {
      case "Privat":
        return <BestillerPrivatPage />;
      case "Selskap":
        return <BestillerSelskapPage />;
      default:
        throw Error("Ukjent aktør, kan ikke vise bestiller-side");
    }
  },
  head: () => ({
    meta: [
      {
        title: "Bestiller | Norgespris for Fjernvarme",
      },
    ],
  }),
});
